import { setCookie, getCookie } from "../cookies/index";
import $ from "jquery";

export default (toastr) => {
	let triggers = $(".js-trigger-register");
	let productForm = $("#productForm");
	let registerForm = $(".register-request-form");
	let bedriftPrivatSwitch = "input[name=register-group]:checked";
	let sameAddressCheck = $("#same-address");
	let bedriftToHide = $(".bedrift-hide");
	let bedriftFields = $(".js-bedrift-input-hide");
	let sameAddressHide = $(".js-sameaddress-hide");
	let userAlreadyExistsInHub = false;
	const ORGANIZATION_NUMBER_API = "https://data.brreg.no/enhetsregisteret/api/enheter/";

	// toastr['warning'](translations['Invalid']);

	$(".form-advance", registerForm).on("click", function (e) {
		e.preventDefault;
		e.stopImmediatePropagation();
		e.stopPropagation();

		let parent = $(this).closest(".group");
		let fields = $(
			"input[type=text], input[type=email], input[type=tel], input[type=checkbox], input[type=number]",
			parent
		);
		let hasInvalidFields = false;
		$(fields).each(function (index, el) {
			if ($(el).attr("required") && $(el).val() == "") {
				$(el).addClass("invalid");
				hasInvalidFields = true;
				return false;
			} else if ($(el).attr("type") == "number" && !isFinite($(el).val())) {
				$(el).addClass("invalid");
				hasInvalidFields = true;
				return false;
			} else {
				$(el).removeClass("invalid");
			}
		});
		if (!hasInvalidFields) {
			let errors = false;
			switch (parent.attr("id")) {
				case "step2":
					if (validateForm("#step2")) {
						enableStep($("#step3"));
						$(".add-person", registerForm).hide();
					} else {
						errors = true;
						return false;
					}
					break;
				case "step3":
					if (validateForm("#step3")) {
						enableStep($("#step4"));
						$(".add-person", registerForm).show();
					} else {
						errors = true;
						return false;
					}
					break;
				case "step4":
					break;
				default:
					if (validateForm("#step1")) {
						enableStep($("#step2"));
						$(".add-person", registerForm).hide();
					} else {
						errors = true;
						return false;
					}
					break;
			}
			if (!errors) {
				$(parent.addClass("collapsed"));
				$(parent.addClass("passed"));
			}
		}
	});

	$(".add-person", registerForm).on("click", function (e) {
		e.preventDefault();
		let hasErrors = false;
		let rEmail =
			/^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i;
		$("#added-persons > ul >li").each(function (index, el) {
			let addedFormIndex = index;
			$("input", this).each(function (childIndex, el) {
				if (
					($(this).attr("required") && $(this).val() == "") ||
					($(this).attr("type") == "email" && !rEmail.test($(this).val()))
				) {
					$(this).addClass("invalid");
					$(this).trigger("focus");
					hasErrors = true;
					return false;
				}
				if ($(this).hasClass("invalid")) {
					hasErrors = true;
					return false;
				}
			});
		});

		if (!hasErrors) {
			let form = $(".add-person-fieldsset.original").clone();
			$("#added-persons > ul").append(`
				<li><h5></h5>
					<div class="remove">
						<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path d="M4.51526 4.30127L11.842 11.6281" stroke="#FF00D9" stroke-width="2"/>
							<path d="M4.51526 11.6284L11.842 4.30164" stroke="#FF00D9" stroke-width="2"/>
						</svg>
					</div>
					${$(form).html()}
				</li>`
			);

			$("#added-persons > ul >li").each(function (index, el) {
				$("input", this).each(function (childIndex, el) {
					let name = $(this).attr("data-name");
					if (name.indexOf("message") < 0) {
						$(this).attr("name", `message[persons][${index}][${name}]`);
					}

					$(this).on("keypress", function (e) {
						var code = e.keyCode ? e.keyCode : e.which;
						if (code == 13) {
							//Enter keycode
							e.preventDefault();
							return false;
						}
					});

					$(this).attr("autocomplete", "off");
				});
			});

			$("#added-persons > ul >li input").each(function (index, el) {
				$(this).attr("disabled", false);
			});
		}
	});

	$(registerForm).on("click", "#added-persons .remove", function (e) {
		e.preventDefault();
		let parent = $(this).closest("li");
		parent.remove();
		updateCart();
	});

	$(registerForm).on("blur", "#added-persons input", function (e) {
		e.preventDefault();
		let parent = $(this).closest("li");
		let rEmail =
			/^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i;
		if (
			($(this).attr("required") && $(this).val() == "") ||
			($(this).attr("type") == "email" && !rEmail.test($(this).val()))
		) {
			$(this).addClass("invalid");
			$(this).trigger("focus");
		} else {
			$(this).removeClass("invalid");
			$(this).addClass("filled");
			if (
				$(this).attr("type") == "email" &&
				$("input#full-name", parent).val() != ""
			) {
				$("h5", parent).text(
					$("input#full-name", parent).val() +
						" " +
						$("input#last-name", parent).val() +
						" - " +
						$(this).val()
				);
				$(parent).addClass("collapsed");
				// $('#firma-antall-deltakere').val($('#added-persons > ul >li').length > 0 ? $('#added-persons > ul >li').length + ($('#participating').is(':checked') === true ? 1 : 0) : 1);
				updateCart();
			}
		}
	});

	$("#phone").on("keypress", function (e) {
		let key = getCode(e);
		if (!isFinite(key)) {
			e.preventDefault();
			e.stopImmediatePropagation();
		}
	});

	$("body").on("keypress", "input[type='tel']", function (e) {
		let key = getCode(e);
		if (!isFinite(key)) {
			e.preventDefault();
			e.stopImmediatePropagation();
		}
	});
	
	$("body").on("keypress", "input[type='number']", function (e) {
		let key = getCode(e);
		if (!isFinite(key)) {
			e.preventDefault();
			e.stopImmediatePropagation();
		}
	});
	
	$('input[name="message[MVA-ORG-nr.]"]').on("blur", function (e) {
		if($(this).val() !== '' && $(this).val().length == 9) {
			$("body").addClass("loading");
			$.getJSON(ORGANIZATION_NUMBER_API + $(this).val(), function( response ) {
				$("body").removeClass("loading");
				if(response.organisasjonsnummer !== undefined) {
					$('input[name="message[Company]"]').val(response.navn !== undefined ? response.navn : '');
					$('input[name="message[Adresse]"]').val(response.forretningsadresse.adresse[0] !== undefined ? response.forretningsadresse.adresse[0] : '');
					$('input[name="message[Land]"]').val(response.forretningsadresse.land !== undefined ? response.forretningsadresse.land : '');
					$('input[name="message[Poststed]"]').val(response.forretningsadresse.poststed !== undefined ? response.forretningsadresse.poststed : '');
					$('input[name="message[Postnr.]"]').val(response.forretningsadresse.postnummer !== undefined ? response.forretningsadresse.postnummer : '');
					$('input[name="message[Company]"]').addClass('filled');
					$('input[name="message[Adresse]"]').addClass('filled');
					$('input[name="message[Land]"]').addClass('filled');
					$('input[name="message[Poststed]"]').addClass('filled');
					$('input[name="message[Postnr.]"]').addClass('filled');
				}
			}).always(function() {
				$("body").removeClass("loading");
			}).fail(function() {
				$("body").removeClass("loading");
			});
		};
	});

	$("body").on("change", 'input[name="register-group"]', function () {
		let activeGroup = $(bedriftPrivatSwitch).val();
		setCookie("coursePublicType", activeGroup.toLowerCase(), 10);
		let showBedrift = activeGroup === "Bedrift";
		bedriftToHide.toggle(showBedrift);
		toggleBedriftFields(showBedrift);
		if (!showBedrift) {
			enableStep($("#step1"));
			$("li", "#added-persons").remove();
		}
		$('.register-request-form input[name="message[Type]"]').val(
			activeGroup.toLowerCase()
		);
		$('.register-request-form input[name="message[Order Type]"]').val(
			activeGroup.toLowerCase() !== "bedrift"
				? "Private course order - not paid"
				: "Company course order - not paid"
		);
	});

	sameAddressCheck.on("change", function () {
		toggleSameAddressFields();
	});

	triggers.on("click", function (e) {
		e.preventDefault();
		if($(this).hasClass("no-checkout")) {
			return false;
		} else {
			$("body").addClass("loading");
			fetch("/actions/strawberry-module/default/clear", {
				method: "GET",
				headers: {
					accept: "application/json",
					"content-type": "application/json",
				},
				body: null,
			})
			.then((res) => res.json())
			.then((result) => {
				$("#dialog-content .dialog-inner").html("");
				$("#dialog-content .dialog-inner").html(result.html);
				submitProductForm();
			});
		}
		return false;
	});

	const validateForm = function (step) {
		let chosenType = $(bedriftPrivatSwitch).val().toLowerCase();
		let error = false;
		if (step === undefined) {
			//Step 1
			$("input[required]", "#step1").each(function (childIndex, el) {
				if (!error) {
					if (
						$(this).val() == "" ||
						$(this).val().length < $(this).attr("minlength") ||
						($(this).attr("type") == "email" && !validateEmail($(this).val()))
					) {
						error = true;
						$(this).addClass("invalid");
						$(this).trigger("focus");
						return;
					} else {
						$(this).removeClass("invalid");
					}
				}
			});
			if (!error && chosenType === "bedrift") {
				//Step 2
				$("input[required]", "#step2").each(function (childIndex, el) {
					if (!error) {
						if (
							$(this).val() == "" ||
							$(this).val().length < $(this).attr("minlength")
						) {
							error = true;
							$(this).addClass("invalid");
							$(this).trigger("focus");
							return;
						} else {
							$(this).removeClass("invalid");
						}
					}
				});
				if (error) {
					enableStep($("#step2"));
					$(".add-person", registerForm).hide();
					$($("#step1").addClass("collapsed"));
					$($("#step1").addClass("passed"));
					return !error;
				}
				//Step 3
				$("input[required]", "#step3").each(function (childIndex, el) {
					if (!error) {
						if (
							$(this).val() == "" ||
							$(this).val().length < $(this).attr("minlength") ||
							($(this).attr("type") == "email" && !validateEmail($(this).val()))
						) {
							error = true;
							$(this).addClass("invalid");
							$(this).trigger("focus");
							return;
						} else {
							$(this).removeClass("invalid");
						}
					}
				});
				if (error) {
					enableStep($("#step3"));
					$(".add-person", registerForm).hide();
					$($("#step2").addClass("collapsed"));
					$($("#step2").addClass("passed"));
					return !error;
				}
				//Step 4
				if ($("#added-persons > ul >li").length == 0) {
					error = false;
				} else {
					// $('input[required]', '#step4').each(function(childIndex, el) {
					// 	if(!error) {
					// 		if($(this).val() == '' || $(this).val().length < $(this).attr('minlength') || ($(this).attr('type') == 'email' && !validateEmail($(this).val()))) {
					// 			error = true;
					// 			$(this).addClass('invalid');
					// 			$(this).trigger('focus');
					// 			return;
					// 		} else {
					// 			$(this).removeClass('invalid');
					// 		}
					// 	}
					// });
				}
				if (error) {
					enableStep($("#step4"));
					$($("#step3").addClass("collapsed"));
					$($("#step3").addClass("passed"));
					$(".add-person", registerForm).show();
					return !error;
				}
			}
		} else {
			$("input[required]", step).each(function (childIndex, el) {
				if (!error) {
					if (
						$(this).val() == "" ||
						$(this).val().length < $(this).attr("minlength") ||
						($(this).attr("type") == "email" && !validateEmail($(this).val()))
					) {
						error = true;
						$(this).addClass("invalid");
						$(this).trigger("focus");
						return;
					} else {
						$(this).removeClass("invalid");
					}
				}
			});
		}
		return !error;
	};

	const getCode = function (e) {
		e = e || window.event;
		return e.key;
	};

	const is_numeric = function (str) {
		return /^\d+$/.test(str);
	};

	const submitProductForm = function () {
		let formData = $(productForm).serialize();

		//Only on empty cart the cookie should be defined
		if ($("#cart #cart-form").length === 0) {
			// let chosenType = getCookie("coursePublicType");
			// console.log(chosenType)
			// if($(productForm).attr("data-public") !== "" && chosenType === undefined || chosenType === "" || chosenType === null) {
			setCookie(
				"coursePublicType",
				$(productForm).attr("data-public").toLowerCase(),
				10
			);
			// }
		}

		$("body").addClass("loading");
		$.ajax({
			type: "POST",
			url: "/",
			dataType: "json",
			headers: {
				"Content-Type": "application/x-www-form-urlencoded",
				"X-Requested-With": "XMLHttpRequest",
				Accept: "application/json",
			},
			data: formData,
			cache: false,
			success: function (response) {
				$("body").removeClass("loading");
				if (response.cart !== undefined) {
					window.location.href = "/bestill";
				}
			},
			error: function (e) {
				$("body").removeClass("loading");
				console.error(e);
			},
		});
	};

	const submitRegisterForm = function (e) {
		if (validateForm() && $("#acceptTerms").prop("checked") == true) {
			$('input[name="fromEmail"]').val(
				$('input[name="message[fromEmail]"]').val()
			);
			let formData = new FormData(registerForm[0]);
			let chosenType = $(bedriftPrivatSwitch).val().toLowerCase();
			formData.append(
				"message[Telephone]",
				$('input[name="message[Country Code]"]').val() +
					$('input[name="message[Telephone]"]').val()
			);
			if (chosenType === "bedrift") {
				formData.append(
					"message[fromName]",
					$('input[name="message[fromName]"]').val()
				);
				formData.append(
					"message[fromLastName]",
					$('input[name="message[fromLastName]"]').val()
				);
				formData.append(
					"message[fromEmail]",
					$('input[name="message[fromEmail]"]').val()
				);
				formData.append(
					"message[MVA-ORG-nr.]",
					$('input[name="message[MVA-ORG-nr.]"]').val()
				);
				formData.append(
					"message[Company]",
					$('input[name="message[Company]"]').val()
				);
				// formData.append('message[Antall deltakere]', $('input[name="message[Antall deltakere]"]').val());
				formData.append(
					"message[Adresse]",
					$('input[name="message[Adresse]"]').val()
				);
				formData.append(
					"message[Postnr.]",
					$('input[name="message[Postnr.]"]').val()
				);
				formData.append(
					"message[Land]",
					$('input[name="message[Land]"]').val()
				);
				formData.append(
					"message[Poststed]",
					$('input[name="message[Poststed]"]').val()
				);
				formData.append(
					"message[Fakturareferanse]",
					$('input[name="message[Fakturareferanse]"]').val()
				);
				formData.append(
					"message[Faktura e-post]",
					$('input[name="message[Faktura e-post]"]').val()
				);
				formData.append(
					"message[Invoice Firmaadresse]",
					$('input[name="message[Invoice Firmaadresse]"]').val()
				);
				formData.append(
					"message[Invoice Firma Postnr.]",
					$('input[name="message[Invoice Firma Postnr.]"]').val()
				);
				formData.append(
					"message[Invoice Firma Poststed]",
					$('input[name="message[Invoice Firma Poststed]"]').val()
				);
				formData.append(
					"message[Invoice Firma Land]",
					$('input[name="message[Invoice Firma Land]"]').val()
				);
				formData.append(
					"message[participating]",
					$("#participating").is(":checked") === true ? 1 : 0
				);

				let invalidUserData = false;
				$("#added-persons > ul >li").each(function (index, el) {
					$("input", this).each(function (childIndex, el) {
						if ($(this).hasClass("invalid") || $(this).val() == "") {
							$(this).addClass("invalid");
							$(this).trigger("focus");
							return false;
						}
					});

					if(!$(this).hasClass('collapsed')) {
						$("input", this).each(function (childIndex, el) {
							if ($(this).hasClass("invalid") || $(this).val() == "") {
								$(this).addClass("invalid");
								$(this).trigger("focus");
								invalidUserData = true;
								return false;
							}
						});
						return false;
					}
				});

				if (invalidUserData) {
					return false;
				} else {
					$("input", registerForm).each(function (index, el) {
						$(el).attr("disabled", false);
					});
					$("#added-persons > ul >li").each(function (index, el) {
						$("input", this).each(function (childIndex, el) {
							formData.append(
								$(el).attr("name"),
								$(el).val()
							);
						});
					});
				}
			}
			$("body").addClass("loading");
			fetch("/actions/strawberry-module/default/save-temp-user", {
				method: "POST",
				headers: { accept: "application/json" },
				body: formData,
			})
				.then((res) => res.json())
				.then((result) => {
					if (result.response) {
						fetch("/actions/strawberry-module/default/get-temp-user", {
							method: "GET",
							eaders: { accept: "application/json" },
						})
							.then((res) => res.json())
							.then((result) => {
								if (result.response) {
									if (
										chosenType !== undefined ||
										chosenType !== "" ||
										chosenType !== null
									) {
										if (chosenType === "bedrift") {
											$("input", registerForm).each(function (index, el) {
												$(el).attr("disabled", false);
											});
											// $(registerForm).trigger("submit");
											window.location.href = '/shop/customer/order?number=' + $('input[name="orderNumber"]', registerForm).val();
										} else {
											if ($(registerForm).attr("data-checkout") == 1) {
												window.location.href = "/shop/checkout/payment";
											} else {
												window.location.href = '/shop/customer/order?number=' + $('input[name="orderNumber"]', registerForm).val();
												// $(registerForm).trigger("submit");
											}
										}
									}
								} else {
									$("body").removeClass("loading");
									console.log("Form error!");
								}
							})
							.catch((error) => {
								$("body").removeClass("loading");
								console.log(error);
							});
					} else {
						console.log("Form error!");
						$("body").removeClass("loading");
					}
				})
				.catch((error) => {
					$("body").removeClass("loading");
					console.log(error);
				});
		} else {
			return false;
		}
	};

	const checkifUserIsRegistered = function (
		firstName,
		lastName,
		email,
		phone,
		address,
		callback
	) {
		return false;
		$("body").addClass("loading");
		let formData = new FormData();
		formData.append("firstName", firstName);
		formData.append("lastName", lastName);
		formData.append("email", email);
		formData.append("phone", phone);
		formData.append("address", address);
		formData.append("acceptTermsAndConditions", true);
		fetch("/actions/strawberry-module/default/validate-user", {
			method: "POST",
			headers: {
				accept: "application/json",
			},
			body: formData,
		})
			.then((res) => res.json())
			.then((result) => {
				$("body").removeClass("loading");
				console.log(result);
				callback(result.data !== undefined ? result.data : null);
			})
			.catch((error) => {
				$("body").removeClass("loading");
				console.log(error);
				callback(null);
			});
	};

	const enableStep = function (step) {
		$(".group input", registerForm).each(function (index, el) {
			$(el).attr("disabled", true);
		});
		$("input", step).each(function (index, el) {
			if ($(el).closest(".js-firmaadresse").length === 0) {
				$(el).attr("disabled", false);
			} else {
				$(el).attr("disabled", true);
			}
		});
		step.removeClass("collapsed");
	};

	const toggleBedriftFields = function (show) {
		if (show) {
			bedriftFields.attr("disabled", false);
		} else {
			bedriftFields.attr("disabled", true);
		}

		toggleSameAddressFields();
	};

	const toggleSameAddressFields = function () {
		if (sameAddressCheck.is(":checked")) {
			sameAddressHide.attr("disabled", true);
		} else {
			sameAddressHide.attr("disabled", false);
		}
	};

	const updateCart = function () {
		//Send update cart
		let updateCartForm = $("#cart-update");
		$("input#cart-input", updateCartForm).val(
			$("#added-persons > ul >li").length > 0
				? $("#added-persons > ul >li").length +
						($("#participating").is(":checked") === true ? 1 : 0)
				: 1
		);
		$("input[name=\"message[participants]\"]").val($("#added-persons > ul >li").length + ($("#participating").is(":checked") === true ? 1 : 0));
		$("body").addClass("loading");
		fetch("/", {
			method: "POST",
			headers: {
				"Content-Type": "application/x-www-form-urlencoded",
				"X-Requested-With": "XMLHttpRequest",
				Accept: "application/json",
			},
			body: $(updateCartForm).serialize(),
		})
			.then((res) => res.json())
			.then((response) => {
				$("body").removeClass("loading");
				if (response.cart !== undefined) {
					console.log(response.cart, response.cart.totalPriceAsCurrency);
					$(".order-summary .itemPrice").text(
						response.cart.totalPrice > 0
							? response.cart.totalPriceAsCurrency
							: ""
					);
					$(".order-summary #itemTotalAsCurrency").text(
						response.cart.totalPrice > 0
							? response.cart.totalPriceAsCurrency
							: ""
					);
					$("input[name=\"message[orderAmount]\"]").val(
						response.cart.totalPrice > 0
							? response.cart.totalPriceAsCurrency
							: ""
					);
				}
			})
			.catch((error) => {
				$("body").removeClass("loading");
				console.log(error);
			});
	};

	const validateEmail = function (email) {
		return String(email)
			.toLowerCase()
			.match(
				/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
			);
	};

	//Show cart buttons
	$(".brand-cta.js-trigger-register").css("display", "flex");

	let chosenType = getCookie("coursePublicType");
	let kurs = $(".order-summary .cart-items .cart-item .left").text().trim();
	if (chosenType !== undefined || chosenType !== "" || chosenType !== null) {
		if (chosenType === "bedrift") {
			$("input[value='Bedrift']").prop("checked", true);
			$("input[value='Privat']").prop("checked", false);
			$(".js-sameaddress-hide").attr("disabled", "disabled");
			$(".bedrift-hide").show();
		} else {
			$("input[value='Bedrift']").prop("checked", false);
			$("input[value='Privat']").prop("checked", true);
			$(".bedrift-hide").hide();
		}
		$('.register-request-form input[name="message[Type]"]').val(chosenType);
		$('.register-request-form input[name="message[Order Type]"]').val(
			chosenType !== "bedrift"
				? "Private course order - not paid"
				: "Company course order - not paid"
		);
		$('.register-request-form input[name="message[Kurs]"]').val(kurs);
	}

	$(".field input", registerForm).on("blur", function (e) {
		if ($(this).attr("type") == "number") {
			if (!isFinite($(this).val())) {
				$(this).removeClass("filled");
				$(this).trigger("focus");
			} else {
				$(this).addClass("filled");
			}
		} else {
			if ($(this).val() === null || $(this).val() === "") {
				$(this).removeClass("filled");
			} else {
				$(this).addClass("filled");
			}
		}
	});

	$(".field input", registerForm).on("keypress", function (e) {
		var code = e.keyCode ? e.keyCode : e.which;
		if (code == 13) {
			//Enter keycode
			e.preventDefault();
			return false;
		}
	});

	$(".fields-group", registerForm).on(
		"click",
		".group.passed > h6",
		function (e) {
			$(".group", registerForm).each(function (index, el) {
				$(el).addClass("collapsed");
			});
			let parent = $(this).closest(".group");
			console.log(parent);
			enableStep($(parent));
		}
	);

	$(".btn-submit", registerForm).on("click", function (e) {
		e.preventDefault();
		submitRegisterForm();
	});
	
	$("#participating", registerForm).on("click", function (e) {
		updateCart();
	});

	$(registerForm).on("submit", function (e) {
		if (validateForm() && $("#acceptTerms").prop("checked") == true) {
			return true;
		} else {
			return false;
		}
	});

	// $('#from-email', '#step1').on('blur', function(e) {
	// 	e.preventDefault();
	// 	if($(this).val() != '' && validateEmail($(this).val())/* && $('#first-name', '#step1').val() != '' && $('#last-name', '#step1').val() != '' && $('#phone', '#step1').val() != ''*/) {
	// 		checkifUserIsRegistered($('#first-name', '#step1').val(), $('#last-name', '#step1').val(), $('#from-email', '#step1').val(), $('#phone', '#step1').val(), '', function(response) {
	// 			if(response !== null && response.existsInHub !== undefined) {
	// 				if(response.existsInHub === true || response.existsInAttensi === true) {
	// 					$('#email-warning-message span').text($('#email-warning-message').attr('data-email-error'));
	// 					$('#email-warning-message').show();
	// 					userAlreadyExistsInHub = true;
	// 				} else {
	// 					$('#email-warning-message').hide();
	// 					userAlreadyExistsInHub = false;
	// 				}
	// 			} else {
	// 				$('#email-warning-message span').text($('#email-warning-message').attr('data-request-error'));
	// 				$('#email-warning-message').show();
	// 				userAlreadyExistsInHub = true;
	// 			}
	// 		});
	// 	}
	// });

	$(".add-person", registerForm).hide();
	if ($(registerForm).length) updateCart();
};
